import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
} from '@mui/material';
import { alterarSenhaAdmin } from '../../../services/usuarioService';

interface ChangePasswordDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  userId: string;
  userName: string;
}

const ChangePasswordDialog: React.FC<ChangePasswordDialogProps> = ({
  open,
  onClose,
  onSuccess,
  userId,
  userName,
}) => {
  const [novaSenha, setNovaSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!novaSenha.trim()) {
      setError('Nova senha é obrigatória');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await alterarSenhaAdmin(userId, novaSenha);
      setNovaSenha('');
      if (onSuccess) {
        onSuccess();
      } else {
        onClose();
      }
    } catch (err: any) {
      setError(err.message || 'Erro ao alterar senha');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setNovaSenha('');
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Alterar Senha - {userName}</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          autoFocus
          margin="dense"
          label="Nova Senha"
          type="password"
          fullWidth
          variant="outlined"
          value={novaSenha}
          onChange={(e) => setNovaSenha(e.target.value)}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading || !novaSenha.trim()}>
          {loading ? 'Alterando...' : 'Alterar Senha'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordDialog;